import { axiosWrapper } from '@/helper/axios-wrapper';

const FEATURE = 'auth';

export const login = async <T = unknown>(email: string, password: string): Promise<T> => {
    const url = `${FEATURE}/signin`;
    return await axiosWrapper.post<T>(url, { email, password }, 320);
};

export const fetchUser = async <T = unknown>(): Promise<T> => {
    const url = `${FEATURE}/profile`;
    return await axiosWrapper.get<T>(url, 0);
};
